import type { NewSensitiveDataScanItem } from "@/_store/endpoint-data-governance/sensitive-data-scans.module";
import { OsType } from "@/constants/devices";

export enum EndpointDgExclusionsActions {
  REMOVE_EXCLUSION = "removeEndpointDgExclusion",
  ADD_FILE_OR_FOLDER = "addEndpointDgExclusion",
  IMPORT_FROM_CSV = "importEndpointDgExclusionsFromCsv",
}

export enum EndpointDgExclusionType {
  FILE = "file",
  FOLDER = "folder",
}

export enum EndpointDgExclusionEnvVariable {
  USERPROFILE = "__USERPROFILE__",
  TEMP = "__TEMP__",
}

export enum SensitiveDataScansActions {
  CREATE = "createSensitiveDataScan",
  EDIT = "editSensitiveDataScan",
  DELETE = "deleteSensitiveDataScan",
}

export enum EndpointDataGovernanceAction {
  SET_INDUSTRY = "setEndpointDataGovernanceIndustry",
}

export enum SensitiveDataScanDriveTypes {
  ALL = "ALL",
  UNENCRYPTED = "UNENCRYPTED",
}

export const SENSITIVE_DATA_SCAN_FREQUENCY_OPTIONS = [21, 14, 7, 3, 1];

export const defaultSensitiveDataItem: NewSensitiveDataScanItem = {
  appliedDriveType: SensitiveDataScanDriveTypes.ALL,
  daysCount: 21,
  osType: OsType.WINDOWS,
  preferredHour: 1,
  labels: [],
};
